<div *ngIf="visible" class="alert alert-warning">
  <div class="titlebar">
      <span style="font-size: small; font-weight: bold; text-transform: uppercase; margin-right: 0.5em;">
        <ng-container *ngIf="environment === 'staging'">
          Staging
        </ng-container>
        <ng-container *ngIf="environment === 'development'">
          Development
        </ng-container>
      </span>
      <ng-container *ngIf="title">&raquo;</ng-container>
      {{ title }}
      <div class="spacer"></div>
      <a href="javascript:;" (click)="remove()">
        <i class="fas fa-times"></i>
      </a>
  </div> 
  <div *ngIf="!shown">
    <a href="javascript:;" (click)="shown = true">Show Details</a>
  </div>
  <div class="content-container" [class.visible]="shown">
    <ng-content></ng-content>
  </div>
</div>